import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchWaitingTimePerService from "../../../components/branches/reports/daily/BranchWaitingTimePerService";
import {
  WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchWaitingTimePerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="WaitingTimePerServiceBranches"
    normalizeData={asArray}
    title={`${reportIndex}. Waiting Time Per Service`}
  >
    {({ data, renderConfig }) => (
      data.map((branch, index) => (
          <BranchWaitingTimePerService
            key={index}
            branchId={branch.branchId}
            reportIndex={reportIndex}
            branchIndex={index + 1}
            data={branch.servicesData}
            branchName={branch.branchName}
            numServices={branch.numServices}
            renderConfig={renderConfig}
          />
        ))
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchWaitingTimePerService;
